import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  label?: string;
}

export function LoadingSpinner({ label }: LoadingSpinnerProps) {
  const { t } = useTranslation('common');
  const displayLabel = label ?? t('loading');
  return (
    <div className="flex items-center justify-center gap-2 py-6" role="status" aria-live="polite">
      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-orange-500"></div>
      <span className="text-sm text-gray-600">{displayLabel}...</span>
    </div>
  );
}
